import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client, { API } from "@/lib/api";
import { FilePdf, ArrowRight } from "@phosphor-icons/react";

export default function AdminReports() {
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    const [{ data: insp }, { data: props }] = await Promise.all([
      client.get("/inspections", { params: { status: "Completed" } }),
      client.get("/properties"),
    ]);
    const pmap = {};
    props.forEach((p) => (pmap[p.id] = p));
    setItems(insp.map((i) => ({ ...i, property: pmap[i.property_id] })));
  }, []);
  useEffect(() => { load(); }, [load]);

  const download = async (id) => {
    const token = localStorage.getItem("trent_token");
    const r = await fetch(`${API}/inspections/${id}/report`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `trent-report-${id}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-reports-page">
      <div className="text-[11px] uppercase tracking-[0.3em] text-[#64748B] mb-1">Admin · Reports</div>
      <h1 className="trent-heading text-3xl md:text-4xl font-black tracking-tighter text-[#0F172A] mb-6">
        Completed reports
      </h1>

      <div className="bg-white border border-[#E5E7EB] rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F1F5F9] text-[10px] uppercase tracking-[0.2em] text-[#64748B]">
            <tr>
              <th className="text-left px-4 py-3">Property</th>
              <th className="text-left px-4 py-3 hidden md:table-cell">Type</th>
              <th className="text-left px-4 py-3 hidden md:table-cell">Inspector</th>
              <th className="text-left px-4 py-3">Date</th>
              <th className="px-4 py-3 w-48 text-right"></th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={5} className="text-center text-[#64748B] py-10">No completed reports yet.</td></tr>
            )}
            {items.map((i) => (
              <tr key={i.id} className="border-t border-[#E5E7EB]" data-testid={`report-row-${i.id}`}>
                <td className="px-4 py-3 font-semibold">{i.property?.address || "—"}</td>
                <td className="px-4 py-3 hidden md:table-cell">{i.inspection_type}</td>
                <td className="px-4 py-3 hidden md:table-cell text-[#475569]">{i.inspector_name}</td>
                <td className="px-4 py-3 text-[#475569]">{i.inspection_date}</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => download(i.id)} className="trent-btn-secondary mr-2" data-testid={`download-${i.id}`}>
                    <FilePdf size={14} /> PDF
                  </button>
                  <Link to={`/admin-dashboard/inspections/${i.id}`} className="text-xs font-semibold uppercase tracking-wider text-[#0F172A] hover:text-[#16A34A] inline-flex items-center gap-1">
                    Open <ArrowRight size={12} weight="bold" />
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
